import React from 'react'
import CorporatePestControlHero from './CorporatePestControlHero'
import CorporatePestControlContent from './CorporatePestControlContent'
import CorporatePestControlServices from './CorporatePestControlServices'
import CorporatePestControlTrustSection from './CorporatePestControlTrustsection'
import CorporatePestControlTransform from './CorporatePestControlTransform'
import Footer from '../../Footer/Footer'







function PestControlCorporate() {
    return (
        <div>
            <CorporatePestControlHero/>
            <CorporatePestControlContent/>
            <CorporatePestControlServices/>
            <CorporatePestControlTrustSection/>
            <CorporatePestControlTransform/>
            <Footer/>
            
        </div>
    )
}

export default PestControlCorporate
